// CheekZee Theme JS

// Mobile nav toggle
const navToggle = document.getElementById('nav-toggle');
const navMenu = document.getElementById('nav-menu');
const navOverlay = document.getElementById('nav-overlay');

if (navToggle) {
  navToggle.addEventListener('click', () => {
    navMenu.classList.toggle('open');
  });
}
if (navOverlay) {
  navOverlay.addEventListener('click', () => {
    navMenu.classList.remove('open');
  });
}

// Scroll reveal
const reveals = document.querySelectorAll('.reveal');
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => entry.target.classList.add('visible'), i * 80);
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });
reveals.forEach(el => observer.observe(el));

// FAQ toggle
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// Cart count update via AJAX
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
    });
}
updateCartCount();

// Add to cart AJAX (intercept product form)
const productForm = document.querySelector('form[action="/cart/add"]');
if (productForm) {
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = this.querySelector('[name="add"]');
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(this)
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = 'Added! 🎉';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = 'Add to Cart 🛒';
        btn.disabled = false;
      }, 2000);
    })
    .catch(() => {
      btn.textContent = 'Error — try again';
      btn.disabled = false;
    });
  });
}
